import type { NavGroup } from '../config/navigation';

export function filterNavGroups(
  groups: readonly NavGroup[],
  isAuthenticated: boolean,
  userRole?: string
): NavGroup[] {
  const result: NavGroup[] = [];

  for (const group of groups) {
    if (group.requiresAuth && !isAuthenticated) continue;
    if (group.publicOnly && isAuthenticated) continue;
    if (group.roles && group.roles.length > 0) {
      if (!userRole || !group.roles.includes(userRole)) continue;
    }

    // For unauthenticated users, flatten public dropdown groups into individual links
    if (!isAuthenticated && !group.requiresAuth && group.items && !group.href) {
      for (const item of group.items) {
        result.push({
          id: `${group.id}-${item.href}`,
          label: item.label,
          href: item.href,
          requiresAuth: false,
        });
      }
      continue;
    }

    result.push(group);
  }

  return result;
}

export function isActivePath(href: string, currentPath: string): boolean {
  if (href === '/admin' && currentPath === '/admin') return true;
  if (href === '/admin') return false;
  return currentPath === href || currentPath.startsWith(href + '/');
}

export function isActiveGroup(group: NavGroup, currentPath: string): boolean {
  if (group.href) {
    return isActivePath(group.href, currentPath);
  }
  if (group.items) {
    return group.items.some((item) => isActivePath(item.href, currentPath));
  }
  return false;
}
